module.exports = __webpack_public_path__ + "img/builder-10.4df0dbff.jpg";